import { SupplyPartRenderer } from "@project/emerge";
import { useRef } from "react";
import type { Group } from "three";

// Vereinfachter AddableRenderer, der den SupplyPartRenderer als Basis verwendet
export const AddableRenderer = ({ id }: { id: string }) => {
  const groupRef = useRef<Group>(null);

  // Den SupplyPartRenderer aufrufen, mit der passenden ID
  // Die Rotation wird direkt auf die group angewendet (90° um X-Achse)
  return (
    <group ref={groupRef} rotation={[Math.PI / 2, 0, 0]}>
      <SupplyPartRenderer id={id} />
    </group>
  );
};
